import { gql } from "@apollo/client";

export const BackgroundTask = gql`
    query BackgroundTask ($id: ID!){
        backgroundTask (id: $id ) {
            id
            taskId
            status
            progressPercentage
        }
    }
`;
